import api, { url } from "@/api";
import { auth } from "@/utils";

const state = {
  avatar: "",
  nickname: "",
  id: 0,
  uuid: "",
  isSignIn: false,
};

const actions = {
  async signCheck() {
    const token = auth.getToken();
    const refreshToken = auth.getRefreshToken();
    if (token) {
      return true;
    } else if (refreshToken) {
      const res = await api.refreshToken(refreshToken).catch(() => {
        auth.signOut();
        return false;
      });
      if (res.access_token) {
        auth.setToken(res.access_token);
        return true;
      } else {
        auth.signOut();
        return false;
      }
    } else {
      return false;
    }
  },
  signIn() {
    window.open(
      url.auth + "?redirect=" + encodeURIComponent(window.location.href),
      "_self"
    );
  },
  signOut() {
    auth.signOut();
    window.open(
      url.auth + "?redirect=" + encodeURIComponent(window.location.href),
      "_self"
    );
  },
  get({ commit }) {
    if (auth.getToken()) {
      return api.profile().then((res) => {
        commit("SET_USER", {
          id: res.id,
          uuid: res.uuid,
          avatar: res.avatar,
          nickname: res.nickname,
          isSignIn: true,
        });
      });
    }
    return;
  },
};

const mutations = {
  SET_USER: (state, user) => {
    state.id = user.id;
    state.uuid = user.uuid;
    state.avatar = user.avatar;
    state.nickname = user.nickname;
    state.isSignIn = user.isSignIn;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
